import { render } from "./AdmBtn.vue?vue&type=template&id=2f407150&scoped=true"
import script from "./AdmBtn.vue?vue&type=script&lang=js"
export * from "./AdmBtn.vue?vue&type=script&lang=js"

import "./AdmBtn.vue?vue&type=style&index=0&id=2f407150&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f407150"]])

export default __exports__